import { useMemo } from "react";
import { useI18n, t } from "@bookingcom/lingojs-react";
import useFormatPrice from "../../../../hooks/useFormatPrice.js";
import usePointOfSale from "../../../../hooks/usePointOfSale.js";
export default function useInsuranceItemController(props) {
    const { travelInsurance, showLoadingPrice } = props;
    const i18n = useI18n();
    const { formatPrice } = useFormatPrice();
    const pointOfSale = usePointOfSale() || "";
    const title = useMemo(() => {
        if (travelInsurance.content?.header)
            return travelInsurance.content.header;
        if (["nz", "au"].includes(pointOfSale))
            return i18n.trans(t("flights_apex_fd_travel_protection_title"));
        if (["mx", "co", "cl", "pe"].includes(pointOfSale))
            return i18n.trans(t("flights_apex_fd_travel_assitance_title"));
        if (["ca", "ch"].includes(pointOfSale))
            return i18n.trans(t("flights_apex_fd_travel_insurance_title"));
        if (["kr"].includes(pointOfSale))
            return i18n.trans(t("flights_apex_cover_insurance_south_korea_title"));
        return i18n.trans(t("flights_apex_travel_protection_title"));
    }, [travelInsurance, pointOfSale, i18n]);
    const description = useMemo(() => {
        if (pointOfSale === "kr")
            return i18n.trans(t("flights_apex_fd_med_insurance_description_travel"));
        return i18n.trans(t("flights_apex_fd_insurance_description_travel"));
    }, [pointOfSale, i18n]);
    const { priceBreakdown } = travelInsurance.options;
    const insurancePrice = formatPrice(priceBreakdown.total);
    const insurancePriceCopy = useMemo(() => travelInsurance.isPerTraveller
        ? i18n.trans(t("flights_apex_fd_insurance_price_pp", { variables: { price: insurancePrice } }))
        : i18n.trans(t("flights_apex_insurance_price_all_travellers", { variables: { price: insurancePrice } })), [i18n, insurancePrice, travelInsurance.isPerTraveller]);
    return {
        title,
        description,
        insurancePriceCopy,
        showLoadingPrice
    };
}
